import { useCallback } from "react";
import type { Node } from "reactflow";
import type { NodeData } from "../lib/api";

type Params = {
  rfNodes: Node<NodeData>[];
  fitView: (opts: any) => void;
  setOverviewNode: (node: NodeData | null) => void;
  setSelectedNodeIds: (ids: string[]) => void;
  setSelectedEdgeIds: (ids: string[]) => void;
  setContactBookOpen: (open: boolean) => void;
};

export function useOverviewNavigation({ rfNodes, fitView, setOverviewNode, setSelectedNodeIds, setSelectedEdgeIds, setContactBookOpen }: Params) {
  const handleNavigateFromContactBook = useCallback(
    (nodeId: string) => {
      const targetNode = rfNodes.find((n) => n.id === nodeId);
      if (targetNode) {
        setOverviewNode(targetNode.data as NodeData);
        setSelectedNodeIds([nodeId]);
        setSelectedEdgeIds([]);
        fitView({ nodes: [{ id: nodeId }], padding: 0.4, duration: 300 });
        setContactBookOpen(false);
      }
    },
    [fitView, rfNodes, setContactBookOpen, setOverviewNode, setSelectedEdgeIds, setSelectedNodeIds]
  );

  const openOverviewForNode = useCallback(
    (nodeId: string) => {
      const targetNode = rfNodes.find((n) => n.id === nodeId);
      if (targetNode) {
        setOverviewNode(targetNode.data as NodeData);
        setSelectedNodeIds([nodeId]);
        setSelectedEdgeIds([]);
        fitView({ nodes: [{ id: nodeId }], padding: 0.4, duration: 300 });
      }
    },
    [fitView, rfNodes, setOverviewNode, setSelectedEdgeIds, setSelectedNodeIds]
  );

  return { handleNavigateFromContactBook, openOverviewForNode };
}
